<template>
  <div class="ov-page">
    <div class="ov-header">
      <div class="ov-note ov-note--info ov-header__note">
        <v-icon small>mdi-information-outline</v-icon>
        <span>{{ $t('travelerCategory.selectSubtitle') }} {{ $t('travelerCategory.adviceText') }}</span>
      </div>
    </div>

    <div class="ov-grid">
      <!-- ===== CATÉGORIES DISPONIBLES ===== -->
      <div class="ov-card">
        <div class="ov-card__head">
          <div class="ov-card__title">
            {{ $t('travelerCategory.availableCategories') }}
            <span class="ov-count">{{ (referenceModeCategorieVoyageurList || []).length }}</span>
          </div>

          <select
            v-if="$store.state.userAuthentified.roleCode == 'RoleAdminSocieteMere' && hasReferences"
            v-model="compagnieTransportRaisonSociale"
            class="ov-select sc-company"
          >
            <option :value="null" disabled>{{ $t('travelerCategory.transportCompany') }}</option>
            <option v-for="c in compagnieTransportList" :key="c.id" :value="c.id">{{ c.raisonSociale }}</option>
          </select>
        </div>

        <div class="ov-card__body">
          <div v-if="!hasReferences" class="ov-empty">
            <div class="sc-empty__title">{{ $t('travelerCategory.noReference') }}</div>
            <div>{{ $t('travelerCategory.createFirstReference') }}</div>
          </div>

          <div v-else class="sc-tiles">
            <button
              v-for="(refCategory, refCat) in referenceModeCategorieVoyageurList"
              :key="refCat"
              type="button"
              class="sc-tile"
              :class="{ 'sc-tile--selected': isSelected(refCategory) }"
              @click="toggleCategory(refCategory)"
            >
              <span class="sc-tile__check">
                <v-icon v-if="isSelected(refCategory)" x-small color="white">mdi-check</v-icon>
              </span>
              <span class="sc-tile__label">{{ refCategory.designation }}</span>
              <span v-if="isAlreadyActive(refCategory)" class="ov-badge ov-badge--success sc-tile__badge">Active</span>
            </button>
          </div>
        </div>

        <div v-if="hasReferences" class="ov-card__foot">
          <span class="sc-foot__count">
            {{ (categoriesSelected || []).length }} {{ $t('travelerCategory.categories') }}
          </span>
          <button type="button" class="ov-btn ov-btn--secondary" @click="reinitSelection">
            {{ $t('travelerCategory.reset') }}
          </button>
          <button type="button" class="ov-btn ov-btn--primary" @click="addNewCategory()">
            <v-icon small>mdi-content-save-outline</v-icon>
            {{ $t('travelerCategory.save') }}
          </button>
        </div>
      </div>

      <!-- ===== CATÉGORIES ACTIVES ===== -->
      <div class="ov-sticky">
        <div class="ov-card">
          <div class="ov-card__head">
            <div class="ov-card__title">
              {{ $t('travelerCategory.selectedCategories') }}
              <span class="ov-count">{{ (categoriesByCompagnieTransport || []).length }}</span>
            </div>
          </div>
          <div class="ov-card__body">
            <div v-if="!categoriesByCompagnieTransport || categoriesByCompagnieTransport.length == 0" class="ov-empty">
              {{ $t('travelerCategory.noCategory') }}
            </div>
            <div v-else class="sc-chips">
              <span v-for="(c, i) in categoriesByCompagnieTransport" :key="i" class="sc-chip">
                {{ c.designation || c }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-alert class="myalert alert-success" type="success" width="350px" dismissible>{{ successMsg }}</v-alert>
    <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
    <v-overlay :value="overlay"><v-progress-circular indeterminate size="56" color="#159e72"></v-progress-circular></v-overlay>
  </div>
</template>

<script>
import {
  API_CREATE_CATEGORY,
  API_GET_ALL_CATEGORY,
  API_OBTENIR_LISTE_DES_DEMANDES_ADHESIONS_VALIDEES,
  API_OBTENIR_REFERENCE_PAR_PAR_FAMILLE,
  HEADERS,
} from "@/components/globalConfig/globalConstConfig";
import {
  showErrorMessage,
  showSuccessMessage,
} from "@/modules/messages/messageProcess";
import axios from "axios";
export default {
  name: "SelectCategory",
  data() {
    return {
      errorMsg: null,
      successMsg: null,
      overlay: false,

      categoriesSelected: [],

      categoriesByCompagnieTransport: [],

      compagnieTransportList: [],

      compagnieTransportRaisonSociale: null,

      retrieveObjectCategory: {
        data: {
          compagnieTransportId:
            this.$store.state.userAuthentified.compagnieTransportId,
        },
      },

      options: {
        index: 0,
        size: 8,
      },

      objectToSendReferenceModeCategorieVoyageur: {
        datas: [],
      },

      categoryByCompagnieObject: {
        datas: [
          {
            compagnieTransportId: null,
          },
        ],
      },

      addNewCategoryObject: {
        data: {
          compagnieTransportId:
            this.$store.state.userAuthentified.compagnieTransportId,
          referenceDTOS: [],
        },
      },

      referenceCategorieVoyageur: {
        referenceFamilleDesignation: "referenceFamilleCategorieVoyageur",
      },

      referenceModeCategorieVoyageurList: [],
    };
  },

  computed: {
    hasReferences() {
      return !!(this.referenceModeCategorieVoyageurList && this.referenceModeCategorieVoyageurList.length);
    },
  },

  methods: {
    reinitSelection() {
      this.categoriesSelected = [];
      if (this.$store.state.userAuthentified.roleCode == "RoleAdminSocieteMere") {
        this.compagnieTransportRaisonSociale = null;
      }
    },

    isSelected(refCategory) {
      return this.categoriesSelected.some(
        (c) => c && refCategory && c.designation === refCategory.designation
      );
    },

    // LA CATÉGORIE EST-ELLE DÉJÀ ACTIVE POUR LA COMPAGNIE ?
    isAlreadyActive(refCategory) {
      return (this.categoriesByCompagnieTransport || []).some(
        (c) => c && refCategory && (c.designation || c) === refCategory.designation
      );
    },

    toggleCategory(refCategory) {
      const idx = this.categoriesSelected.findIndex(
        (c) => c && refCategory && c.designation === refCategory.designation
      );
      if (idx >= 0) {
        this.categoriesSelected.splice(idx, 1);
      } else {
        this.categoriesSelected.push(refCategory);
      }
    },
    

    //OBTENIR REFERENCE DESIGNATION CATEGORIE VOYAGEUR
    async getAllCategoryByCompagnieTransport() {
      await axios
        .post(API_GET_ALL_CATEGORY, this.retrieveObjectCategory, {
          headers: HEADERS(this.$store.state.userAuthentified.token),
        })
        .then((response) => {
          // Vérifier que la réponse contient bien les données attendues
          if (response.data && response.data.item && response.data.item.referenceDTOS) {
            this.categoriesByCompagnieTransport = response.data.item.referenceDTOS;
          } else {
            this.categoriesByCompagnieTransport = [];
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
          // S'assurer que la variable est toujours un tableau même en cas d'erreur
          this.categoriesByCompagnieTransport = [];
        });
    },


    // OBTENIR LA LISTE DES DEMANDES D'ADHESIONS VALIDÉES
    async getCompagnieTransportList() {
      if (
        this.$store.state.userAuthentified.roleCode == "RoleAdminSocieteMere"
      ) {
        axios
          .post(
            API_OBTENIR_LISTE_DES_DEMANDES_ADHESIONS_VALIDEES,
            this.options,
            {
              headers: HEADERS(this.$store.state.userAuthentified.token),
            }
          )
          .then((response) => {
            if (response.status == 200) {
              if (response.data.status.code != 800) {
                this.errorMsg = response.data.status.message;
                showErrorMessage();
                this.compagnieTransportList = [];
              } else {
                this.compagnieTransportList = response.data.items || [];
              }
            } else {
              this.errorMsg = this.$t('travelerCategory.dataError');
              showErrorMessage();
              this.compagnieTransportList = [];
            }
          })
          .catch((e) => {
            this.errorMsg = e;
            showErrorMessage();
            this.compagnieTransportList = [];
          });
      }
    },

    //GET ALL CATEGORIES TRAVELLERS.
    async getAllCategoryTravellers() {
      this.objectToSendReferenceModeCategorieVoyageur.datas.push(
        this.referenceCategorieVoyageur
      );
      await axios
        .post(
          API_OBTENIR_REFERENCE_PAR_PAR_FAMILLE,
          this.objectToSendReferenceModeCategorieVoyageur,
          { headers: HEADERS(this.$store.state.userAuthentified.token) }
        )
        .then((response) => {
          // Vérifier que la réponse contient bien les données attendues
          if (response.data && response.data.items) {
            this.referenceModeCategorieVoyageurList = response.data.items;
          } else {
            this.referenceModeCategorieVoyageurList = [];
          }
        })
        .catch((e) => {
          this.errorMsg = e;
          showErrorMessage();
          // S'assurer que la variable est toujours un tableau même en cas d'erreur
          this.referenceModeCategorieVoyageurList = [];
        });
    },

    // ADD NEW CATEGORY
    async addNewCategory() {
      var referenceToSend = [];
      if (
        this.$store.state.userAuthentified.roleCode == "RoleAdminSocieteMere"
      ) {
        if (
          this.compagnieTransportRaisonSociale == null ||
          this.compagnieTransportRaisonSociale == ""
        ) {
          this.errorMsg = this.$t('travelerCategory.selectCompany');
          showErrorMessage();
        } else {
          if (this.categoriesSelected.length == 0) {
            this.errorMsg = this.$t('travelerCategory.noCategorySelected');
            showErrorMessage();
          } else {
            this.overlay = true;
            this.categoriesSelected.forEach((element) => {
              var referenceCategory = {
                designation: element.designation,
              };
              referenceToSend.push(referenceCategory);
            });
            this.addNewCategoryObject.data.compagnieTransportId =
              this.compagnieTransportRaisonSociale;
            this.addNewCategoryObject.data.referenceDTOS = referenceToSend;
            await axios
              .post(API_CREATE_CATEGORY, this.addNewCategoryObject, {
                headers: HEADERS(this.$store.state.userAuthentified.token),
              })
              .then(async (response) => {
                if (
                  response.data.status.code !== "800" ||
                  response.data.status.hasError == true
                ) {
                  this.errorMsg = response.data.status.message;
                  showErrorMessage();
                } else {
                  this.successMsg = response.data.status.message;
                  showSuccessMessage();
                  await this.getAllCategoryByCompagnieTransport();
                }
              })
              .catch((e) => {
                this.errorMsg = e;
                showErrorMessage();
              })
              .finally(() => {
                this.overlay = false;
                this.categoriesSelected = [];
                this.addNewCategoryObject.data.compagnieTransportId = null;
                this.addNewCategoryObject.data.referenceDTOS = [];
                this.compagnieTransportRaisonSociale = null;
              });
          }
        }
      } else {
        if (this.categoriesSelected.length == 0) {
          this.errorMsg = this.$t('travelerCategory.noCategorySelected');
          showErrorMessage();
        } else {
          this.overlay = true;
          this.categoriesSelected.forEach((element) => {
            var referenceCategory = {
              designation: element.designation,
            };
            referenceToSend.push(referenceCategory);
          });
          this.addNewCategoryObject.data.compagnieTransportId =
            this.$store.state.userAuthentified.compagnieTransportId;
          this.addNewCategoryObject.data.referenceDTOS = referenceToSend;
          await axios
            .post(API_CREATE_CATEGORY, this.addNewCategoryObject, {
              headers: HEADERS(this.$store.state.userAuthentified.token),
            })
            .then(async (response) => {
              if (
                response.data.status.code !== "800" ||
                response.data.status.hasError == true
              ) {
                this.errorMsg = response.data.status.message;
                showErrorMessage();
              } else {
                this.successMsg = response.data.status.message;
                showSuccessMessage();
                await this.getAllCategoryByCompagnieTransport();
              }
            })
            .catch((e) => {
              this.errorMsg = e;
              showErrorMessage();
            })
            .finally(() => {
              this.overlay = false;
              this.categoriesSelected = [];
              this.addNewCategoryObject.data.compagnieTransportId = null;
              this.addNewCategoryObject.data.referenceDTOS = [];
              this.compagnieTransportRaisonSociale = null;
            });
        }
      }
    },
  },

  mounted() {
    this.getAllCategoryByCompagnieTransport()
    this.getAllCategoryTravellers();
    this.getCompagnieTransportList();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/admin/ui";

.sc-company {
  width: auto;
  min-width: 240px;
  height: 40px;
}

.sc-empty__title {
  font-weight: 800;
  color: $ov-navy;
  margin-bottom: 4px;
}

.sc-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.sc-tile {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 14px 16px;
  text-align: left;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: rgba(21, 158, 114, 0.45);
  }

  &--selected {
    border-color: $ov-green;
    background: rgba(21, 158, 114, 0.06);
    box-shadow: 0 0 0 3px rgba(21, 158, 114, 0.12);
  }
}

.sc-tile__check {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 2px solid rgba(15, 23, 42, 0.2);
  transition: background 0.2s ease, border-color 0.2s ease;

  .sc-tile--selected & {
    background: $ov-green;
    border-color: $ov-green;
  }
}

.sc-tile__label {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 700;
  color: $ov-navy;
}

.sc-tile__badge {
  padding: 2px 8px;
  font-size: 11px;
}

.sc-foot__count {
  margin-right: auto;
  font-size: 13px;
  font-weight: 700;
  color: $ov-muted;
}

.sc-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.sc-chip {
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  color: $ov-green-dark;
  background: rgba(21, 158, 114, 0.08);
  border: 1px solid rgba(21, 158, 114, 0.18);
}
</style>
